import { useNavigate } from "react-router-dom";
import HeaderMain from "./Components/HeaderMain.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faHome,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";

const PageNotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="App max-w-7xl mx-auto">
      <HeaderMain pageType="404" />

      <main className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-100 flex items-center justify-center px-4">
        <div className="text-center max-w-2xl mx-auto">
          {/* Error Icon */}
          <div className="mb-8">
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              className="text-8xl md:text-9xl text-[#0071bc] opacity-80 animate-pulse"
            />
          </div>

          {/* 404 Title */}
          <div className="mb-6">
            <h1 className="text-8xl md:text-9xl font-black text-gray-800 mb-4">
              404
            </h1>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-700 mb-4">
              Page Not Found
            </h2>
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
              Oops! The page you're looking for doesn't exist. It might have
              been moved, deleted, or you entered the wrong URL.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={handleGoHome}
              className="flex w-full sm:w-auto items-center gap-3 bg-[#0071bc] text-white px-8 py-4 rounded-lg font-semibold text-base sm:text-lg hover:bg-[#005a94] transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <FontAwesomeIcon icon={faHome} className="text-xl" />
              Go to Home
            </button>

            <button
              onClick={handleGoBack}
              className="flex w-full sm:w-auto items-center gap-3 bg-white text-[#0071bc] border-2 border-[#0071bc] px-8 py-4 rounded-lg font-semibold text-base sm:text-lg hover:bg-[#0071bc] hover:text-white transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <FontAwesomeIcon icon={faArrowLeft} className="text-xl" />
              Go Back
            </button>
          </div>

          {/* Additional Help */}
          <div className="mt-12 p-6 bg-white rounded-xl shadow-lg border border-gray-200">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              Need Help?
            </h3>
            <div className="text-gray-600 space-y-2">
              <p>• Check the URL for any spelling mistakes</p>
              <p>• Use the navigation menu to find what you're looking for</p>
              <p>• Return to the homepage and start over</p>
              <p>• Contact our support team if you believe this is an error</p>
            </div>
          </div>

          {/* Sports Theme Element */}
          <div className="mt-8 opacity-20">
            <div className="flex justify-center space-x-4 text-4xl">
              <span>⚽</span>
              <span>🏀</span>
              <span>🏈</span>
              <span>🎾</span>
              <span>🏐</span>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PageNotFound;
